import { createFileRoute } from "@tanstack/react-router";
import { CallAudioDashboard } from "../tools/dashboards/CallAudioDashboard";

export const Route = createFileRoute("/_app/dashboards/call-audio")({
  component: CallAudioDashboard,
});
